/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2024-05-31 11:54:20
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\index.tsx
 * @Description: 
 */
import { Form, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import Forget from './forget';
import './index.scss'; // 引入样式文件
import Login from './login';
import Register from './register';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoginShow, selectUserId, setLoginShow } from '../../store/reducers/userInfo';
import VerifyIdentity from './verifyIdentity';
import UpPassword from './upPassword';
import SelectLoginUser from './selectLoginUser';

const UserMaage: React.FC<any> = () => {

  const loginShow = useSelector(selectLoginShow);
  const userId = useSelector(selectUserId);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [isloading, setIsloading] = useState<boolean>(false); // 加载状态
  const [pageType, setPageType] = useState<string>('login'); // 页面类型
  const [tempIdCard, setTempIdCard] = useState<string>(''); // 临时身份证
  const [tempPhone, setTempPhone] = useState<string>(''); // 临时手机号
  const [userData, setUserData] = useState<any>([]); // 多用户
  const [code, setCode] = useState<string>(''); // 验证码code
  
  const pageStyle = () => {
    let height = 400;
    let width = 428;
    switch (pageType) {
      case 'login':
        height = 400;
        width = 428;
        break;
      case 'register':
        height = 613;
        width = 428;
        break;
      case 'forget':
        height = 330;
        width = 428;
        break;
      case 'verifyIdentity':
        height = 400;
        width = 428;
        break;
      case 'upPassword':
        height = 330;
        width = 428;
        break;
      case 'selectLoginUser':
        height = 475;
        width = 500;
        break;
      default:
        break;
    }
    return { height, width }
  }

  useEffect(() => {
    setIsloading(false);
    setPageType(userId ? 'forget' : 'login');
    const formData = form.getFieldsValue();
    form.setFieldsValue({
      ...formData,
      idCard: '',
      password: '',
      phone: '',
      code: ''
    });
  }, [loginShow, userId])

  return (
    <>
      {loginShow &&
        <div className={`userMaage show`}>
          <div
            className="userMaage-dialog"
            style={pageStyle()}>
            <Spin style={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              zIndex: isloading ? 1 : -1
            }} spinning={isloading}
            />
            <div className={`login_title ${pageType}`}>
              {(() => {
                switch (pageType) {
                  case 'login':
                    return '用户登录'
                  case 'register':
                    return '注册'
                  case 'forget':
                    return userId ? '修改密码' : '忘记密码'
                  case 'verifyIdentity': 
                    return '验证身份'
                  case 'upPassword': 
                    return '重置密码'
                  case 'selectLoginUser':
                    return '选择登录的账号'
                  default:
                    return null
                }
              })()}
            </div>
            <Form
              name="basic"
              initialValues={{ remember: true }}
              form={form}
            >
              {(() => {
                switch (pageType) {
                  case 'login':
                    return <Login
                      form={form}
                      setIsloading={setIsloading}
                      onRegister={() => setPageType('register')}
                      onForget={() => setPageType('forget')}
                      onSelectLoginUser={(userData, phone) => {
                        setTempPhone(phone);
                        setUserData(userData);
                        setPageType('selectLoginUser');
                      }}
                    />
                  case 'register':
                    return <Register
                      form={form}
                      setIsloading={setIsloading}
                      onLogin={() => setPageType('login')}
                    />
                  case 'forget':
                    return <Forget
                      form={form}
                      setIsloading={setIsloading}
                      onLogin={() => setPageType('login')}
                      onUpPassword={(phone) => {
                        setPageType('upPassword');
                        setTempPhone(phone);
                      }}
                      setCode={setCode}
                    />
                  case 'verifyIdentity':
                    return <VerifyIdentity
                      form={form}
                      setIsloading={setIsloading}
                      onUpPassword={(idCard, phone) => {
                        setPageType('upPassword');
                        setTempIdCard(idCard);
                        setTempPhone(phone);
                      }}
                    />
                  case 'upPassword':
                    return <UpPassword
                      form={form}
                      setIsloading={setIsloading}
                      onLogin={() => setPageType('login')}
                      idCard={tempIdCard}
                      phone={tempPhone}
                      code={code}
                    />
                  case 'selectLoginUser':
                    return <SelectLoginUser
                      setIsloading={setIsloading}
                      phone={tempPhone}
                      data={userData}
                    />
                  default:
                    return null
                }
              })()}
            </Form>
            <div className='closs_cls' onClick={() => {
              dispatch(setLoginShow(false));
              return
              if (pageType === 'login' || pageType === 'register' || userId) {
                dispatch(setLoginShow(false));
              } else {
                setPageType('login')
              }
            }}></div>
          </div>
        </div>}
    </>
  );
};

export default UserMaage;
